import { normalizeDocumentLanguage, manufacturingTranslator } from './manufacturingLanguage.js';

// Reviewed names from the existing catalogue. GFJ is an internal reference.
const chineseColors = {
  "negro": "黑色",
  "azul": "蓝色",
  "beig": "米色",
  "berenjena": "茄紫色",
  "kaki": "军绿色",
  "crudo": "本白色",
  "gris vigore": "麻灰色",
  "turquesa": "绿松石色",
  "menta": "薄荷绿",
  "rosa": "粉色",
  "rojo": "红色",
  "marron": "棕色",
  "tejano": "牛仔蓝",
  "marengo": "炭灰色",
  "marino": "藏青色",
  "coral": "珊瑚色",
  "amarillo claro": "浅黄色",
  "mostaza": "芥末黄",
  "camel": "驼色",
  "v.botella": "瓶绿色",
  "fuxia": "玫红色",
  "celeste": "天蓝色",
  "lila": "淡紫色",
  "kaki claro": "浅军绿色",
  "pistacho": "开心果绿",
  "naranja": "橙色",
  "gris claro": "浅灰色",
  "mandarina": "橘色",
  "granate": "酒红色"
};
const normalize = (value) => String(value || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export function defaultChineseColor(description) {
  return chineseColors[normalize(description)] || '';
}

export function localizedColorDescription(settings, language = 'es') {
  const es = settings?.description?.trim() || '';
  const zh = settings?.description_zh?.trim() || defaultChineseColor(es);
  const lang = normalizeDocumentLanguage(language);
  if (lang === 'es' || !zh) return es;
  return lang === 'zh' || !es ? zh : `${es} / ${zh}`;
}

// Material assignments may contain a catalogue code or a free-text colour.
export function localizedMaterialColor(value, settings = {}, language = 'es') {
  const configured = settings[value] || Object.values(settings).find((color) =>
    color?.description && normalize(color.description) === normalize(value));
  const description = localizedColorDescription(configured || { description: value }, language);
  return description && description !== value ? description : manufacturingTranslator(language)(value);
}
